module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row expanded small-collapse img-txt-pnls"
  }, [_c('div', {
    staticClass: "small-12 large-6 columns img video"
  }, [_c('a', {
    on: {
      "click": _vm.play
    }
  }, [_c('span', [_c('span', {
    staticClass: "vd-aspct",
    style: ({
      backgroundImage: "url(" + _vm.img + ")"
    })
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 large-6 columns txt"
  }, [_c('div', {
    staticClass: "pddxy-50"
  }, [_c('h3', [_vm._v("In video:")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("truncate")(_vm.description, 150, '...')))]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "bttn-lrg",
    attrs: {
      "href": "#/"
    },
    on: {
      "click": _vm.play
    }
  }, [_vm._v("Watch video")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "reveal large",
    attrs: {
      "id": "modal-ytvideo",
      "data-reveal": ""
    }
  }, [_c('div', {
    staticClass: "responsive-embed widescreen"
  }, [_c('youtube', {
    attrs: {
      "video-id": _vm.videoId
    },
    on: {
      "ready": _vm.ready,
      "ended": _vm.ended
    }
  })], 1), _vm._v(" "), _vm._m(0, false, false)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close-button",
    attrs: {
      "data-close": "",
      "aria-label": "Close modal",
      "type": "button"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cdaf80e6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=ba0n6m0pdol!./~/string-replace-webpack-plugin/loader.js?id=vjdso5oqwij!./src/components/YoutubeVideo.vue
// module id = 687
// module chunks = 0